import { ClassicPreset } from "rete";

export class RedirectControl extends ClassicPreset.Control {
  constructor(public value: Number, public onChange: (evt: any) => void) {
    super();
  }
}